import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RequestComponent } from './pages/request/request.component';
import { RequestRoleGuard } from './shared/guards/RequestRoleGuard';
import { GetURLComponent } from './pages/get-url/get-url.component';
import { UploadToStagingComponent } from './pages/upload-to-staging/upload-to-staging.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/dashboard/dashboard.component').then(
        (m) => m.DashboardComponent
      ),
  },
  {
    path: 'Client/:clientId',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/engagement/engagement.component').then(
        (m) => m.EngagementComponent
      ),
  },
  {
    path: 'Client/:clientId/EngagementId/:engagementId',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/engagement-summary/engagement-summary.component').then(
        (m) => m.EngagementSummaryComponent
      ),
  },
  {
    path: 'Client/:clientId/EngagementId/:engagementId/moduleId/:moduleId',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/module/module.component').then((m) => m.ModuleComponent),
  },

  {
    path: 'Client/:clientId/EngagementId/:engagementId/RequestModule',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/module/module-catalog/module-catalog.component').then(
        (m) => m.ModuleCatalogComponent
      ),
  },

  {
    path: 'Client/:clientId/EngagementId/:engagementId/RequestModule/manifest-creator',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/module/module-catalog/manifest-creator/manifest-creator.component').then(
        (m) => m.ManifestCreatorComponent
      ),
  },

  {
    path: 'Request',
    canActivate: [MsalGuard, RequestRoleGuard],
    loadComponent: () =>
      import('./pages/request/request.component').then(
        (m) => m.RequestComponent
      ),
  },
  {
    path: 'Request/:requestId',
    canActivate: [MsalGuard, RequestRoleGuard],
    component: RequestComponent,
  },
  {
    path: 'GetDownloadURL/EngagementId/:engagementId/ModuleId/:moduleId/RunId/:runId',
    canActivate: [MsalGuard],
    component: GetURLComponent,
  },
  {
    path: 'GetSupportedFile/:engagementId/:moduleId',
    canActivate: [MsalGuard],
    component: GetURLComponent,
  },
  {
    path: 'UploadToStaging/runid/:runId',
    canActivate: [MsalGuard],
    component: UploadToStagingComponent,
  },
  {
    path: 'RequestEngagement',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/shared/request-panel/request-wrapper/engagement-request-wrapper/engagementrequest/engagementrequest.component').then(
        (m) => m.EngagementrequestComponent
      ),
  },
  {
    path: 'RequestEngagementSuccess/:engagementName',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import(
        './pages/shared/request-panel/request-wrapper/engagement-request-wrapper/engagementrequestsuccess/engagementrequestsuccess.component'
      ).then((m) => m.EngagementrequestsuccessComponent),
  },
  {
    path: 'no-access',
    canActivate: [],
    loadComponent: () =>
      import('./pages/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent
      ),
  },
  {
    path: 'login-failed',
    loadComponent: () =>
      import('./pages/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent
      ),
  },
];
